module.exports = __webpack_public_path__ + "static/activebarre-foot-extension-6dd1e2e275b0605e5031dda8b2ad50f0.jpg";